<!-- 处理异常 -->
<template>
    <modal :visible.sync="visible" :title="$t('integration.handle_event')" append-to-body width="450px">
        <div>
            <HandleEx :detail="detail" ref="handleEx"></HandleEx>
        </div>
        <template #footer>
            <el-button type="primary" @click="save">{{ $t('integration.preservation') }}</el-button>
            <el-button type="primary" @click="cancel">{{ $t('integration.cancel') }}</el-button>
        </template>
    </modal>
</template>
<script>
import bus from '@/utils/bus';
import HandleEx from './HandleEx.vue';
import { exHandle } from "@/api/modules/abnormal";

export default {
    props: ['exId'],
    components: {
        HandleEx
    },
    data() {
        return {
            visible: false,
            detail: [],

            // 执行完成后的回调
            callback: null
        }
    },
    mounted() {
        bus.$on('handleEx', ({ detail, callback }) => {
            this.visible = true;
            this.detail = detail;
            if (this.$refs['handleEx'])
                this.$refs['handleEx'].reset();
            if (callback) {
                this.callback = callback;
            }
        });
    },
    methods: {
        async save() {
            const data = await this.$refs['handleEx'].getData();
            const ids = this.detail.map(item => item.id);
            exHandle({
                exIds: ids,
                process: { ...data }
            }).then(({ result }) => {
                this.visible = false;
                this.$refs['handleEx'].handleResult(result, () => {
                    if (this.callback) {
                        this.callback();
                    }
                })
            })
        },
        cancel() {
            this.visible = false;
        }
    },
    beforeDestroy() {
        bus.$off('handleEx');
    }
}
</script>